const podcastType = {
    podcast: 1,
    podcastGroup: 2,
};

export default podcastType;
